var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',[_c('b-datepicker',{attrs:{"value":_vm.value},on:{"input":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }